module.exports = __webpack_public_path__ + "static/media/banner_img.b90b6451.png";